import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MarkdownService } from '../../../../../services/markdown.service';

@Component({
  selector: 'app-ai-message-tool',
  templateUrl: './ai-message-tool.component.html',
  styleUrls: ['./ai-message-tool.component.scss']
})
export class AiMessageToolComponent {
  @Input() toolName: string = '';
  @Input() toolInput: any;
  @Input() toolOutput: any;
  @Input() explanation: string = '';
  @Input() isLoading: boolean = false;
  parsedOutput: SafeHtml = '';
  parsedInput: SafeHtml = '';
  rawInput: string = '';
  rawOutput: string = '';

  constructor(
    private markdownService: MarkdownService,
    private sanitizer: DomSanitizer
  ) {}

  formatJson(obj: any): string {
    if (typeof obj === 'string') {
      return obj;
    }
    return '```json\n' + JSON.stringify(obj, null, 2) + '\n```';
  }

  async ngOnChanges() {
    if (this.toolInput) {
      this.rawInput = typeof this.toolInput === 'string' ? this.toolInput : JSON.stringify(this.toolInput, null, 2);
      const formattedInput = this.formatJson(this.toolInput);
      const parsedInput = await this.markdownService.parse(formattedInput);
      this.parsedInput = this.sanitizer.bypassSecurityTrustHtml(parsedInput);
    }
    
    if (this.toolOutput) {
      this.rawOutput = this.toolOutput;
      const parsed = await this.markdownService.parse(this.toolOutput || '');
      this.parsedOutput = this.sanitizer.bypassSecurityTrustHtml(parsed);
    }
  }

  copyToClipboard(content: string): void {
    const textarea = document.createElement('textarea');
    textarea.value = content;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  }
}